define("appkit/controllers/deck", 
  ["exports"],
  function(__exports__) {
    "use strict";
    __exports__["default"] = Ember.ArrayController.extend({

      actions: {

        'new': function() {
          this.get('deck').createNewSlide();
        },

        save: function(slide) {
          this.get('deck').saveSlide(slide);
        }

      }

    });
  });